module.exports = __webpack_public_path__ + "assets/img/tit3.59c01881.png";